import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import AcademicService from "../../services/AcademicDegreeService";
import AcademicDegree from "../../models/AcademicDegree";
import AcademicDegreeService from "../../services/AcademicDegreeService";
import OptionItem from "../../models/OptionItem";

export class ReRegistrationAcademicDegreeFormItem {
    Id: number;
    Title: string;
    TitleValue: any
    Institution: string | undefined;
    YearCompletion: number | undefined;
    Course: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, Title: any, Institution?: string, Course?: string, YearCompletion?: number) {
        this.Id = Id;
        this.Title = Title.Text;
        this.TitleValue = Title;
        this.Institution = Institution;
        this.Course = Course;
        this.YearCompletion = YearCompletion;
    }

    static NewInstance(): ReRegistrationAcademicDegreeFormItem {
        return new ReRegistrationAcademicDegreeFormItem(0, "", "", "");
    }

}

export default class ReRegistrationAcademicDegreeForm implements FormBase {

    Title: FormFieldBase;
    TitleValue: any;
    Institution: FormFieldBase;
    YearCompletion: FormFieldBase;
    Course: FormFieldBase;
    FormItemList: ReRegistrationAcademicDegreeFormItem[];
    FormRemoveList: ReRegistrationAcademicDegreeFormItem[];
    FormItemToEdit: ReRegistrationAcademicDegreeFormItem;

    constructor(Title: string, Institution: string, Course: string, YearCompletion: string) {

        this.Title = new FormFieldBase(Title, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.Institution = new FormFieldBase(Institution, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.YearCompletion = new FormFieldBase(YearCompletion, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.Course = new FormFieldBase(Course, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.FormItemList = new Array<ReRegistrationAcademicDegreeFormItem>();
        this.FormRemoveList = new Array<ReRegistrationAcademicDegreeFormItem>();
        this.FormItemToEdit = ReRegistrationAcademicDegreeFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationAcademicDegreeFormItem() {

        this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

        this.Title.Mandatory = true;
        this.Institution.Mandatory = true;
        this.YearCompletion.Mandatory = true;
        this.Course.Mandatory = true;

        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = new ReRegistrationAcademicDegreeFormItem(
                    this.getNewId(),
                    this.Title.Value,
                    this.Institution.Value,
                    this.Course.Value,
                    this.YearCompletion.Value
                )

                this.FormItemList.push(item);

            //Update    
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = new ReRegistrationAcademicDegreeFormItem(
                            element.Id,
                            this.Title.Value,
                            this.Institution.Value,
                            this.Course.Value,
                            this.YearCompletion.Value
                        )
                        
                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    
    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        if ((this.FormItemList !== null && this.FormItemList.length > 0) || (this.FormRemoveList !== null && this.FormRemoveList.length > 0)) {
            const dataJson = this.getJsonObjet();
            return AcademicService.postInsertOrUpdateAcademic(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await AcademicDegreeService.CreateAndGetAcademicDegreeFromTasy(requestId).then((data: AcademicDegree[]) => {

            this.FormItemList = new Array<ReRegistrationAcademicDegreeFormItem>();
            this.FormRemoveList = new Array<ReRegistrationAcademicDegreeFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let titleOption: OptionItem | undefined = undefined;

                if (element.TitleId !== undefined && element.TitleValue !== undefined) {
                    titleOption = new OptionItem(element.TitleId, element.TitleValue, element.TitleId.toString());
                }
                
                let item = new ReRegistrationAcademicDegreeFormItem(
                    this.getNewId(),
                    titleOption,
                    element.InstitutionName,
                    element.CourseName,
                    element.YearCompletion
                )
                
                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationAcademicDegreeFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Title.Value = this.FormItemToEdit.TitleValue;
                this.Institution.Value = this.FormItemToEdit.Institution;
                this.Course.Value = this.FormItemToEdit.Course;
                this.YearCompletion.Value = this.FormItemToEdit.YearCompletion;
            }
        }
    }

    RemoveReRegistrationAcademicDegreeFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if(element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                }else{
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }

    ValidateToGoNextStep(): string {
        return "";
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

            this.Title.Mandatory = true;
            this.Institution.Mandatory = true;
            this.YearCompletion.Mandatory = true;
            this.Course.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];
                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }

            if (existFieldImputed) {
                this.Title.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

                this.Title.Mandatory = true;
                this.Institution.Mandatory = true;
                this.YearCompletion.Mandatory = true;
                this.Course.Mandatory = true;
            } else {
                this.Title.Validations = [];
                this.Institution.Validations = [];
                this.YearCompletion.Validations = [];
                this.Course.Validations = [];
                this.Title.Error = "";
                this.Institution.Error = "";
                this.YearCompletion.Error = "";
                this.Course.Error = "";
                this.Title.Mandatory = false;
                this.Institution.Mandatory = false;
                this.YearCompletion.Mandatory = false;
                this.Course.Mandatory = false;
            }
        }
    }

    static NewInstance(): ReRegistrationAcademicDegreeForm {
        return new ReRegistrationAcademicDegreeForm("", "", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationAcademicDegreeFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Title":
                return this.Title
            case "Institution":
                return this.Institution
            case "YearCompletion":
                return this.YearCompletion
            case "Course":
                return this.Course

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList != null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationAcademicDegreeFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "titleId": element.TitleValue.Id,
                    "institutionName": element.Institution,
                    "courseName": element.Course,
                    "yearCompletion": (element.YearCompletion !== undefined ? parseInt(element.YearCompletion.toString()) : undefined),
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationAcademicDegreeFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "titleId": element.TitleValue.Id,
                    "institutionName": element.Institution,
                    "courseName": element.Course,
                    "yearCompletion": (element.YearCompletion !== undefined ? parseInt(element.YearCompletion.toString()) : undefined),
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}